export default __webpack_public_path__ + "static/media/m28.3b543f90.jpg";